import $ from 'jquery';
import Popover from 'bootstrap/js/src/popover';
import abTestService from '../services/abTestService';
import ajaxService from '../services/ajaxService';
import contentService from '../services/contentService';
import {lazyLoad} from '../helpers/lazyLoadHelpers';
import {getTestNameFromVariation} from '../helpers/abTestHelpers';

class SubscribeToArrangementChangesComponent {
	constructor(params) {
		this.params = params;
		
		this.#init();
	}
	
	#init() {
		const {buttonElements} = this.params;
		
		if (!buttonElements.length) {
			return;
		}
		
		// check if hover is supported on the device
		if (window.matchMedia('(hover: hover)').matches) {
			buttonElements.forEach((btn) => {
				new Popover(btn, {});
			});
		}
		
		this.#initEvents();
	}
	
	#initEvents() {
		this.params.buttonElements.forEach((btn) => {
			btn.addEventListener(
				'click',
				() => {
					abTestService.sendEvent(
						getTestNameFromVariation('allowSubscribeToArrangementChanges_no', 'allowSubscribeToArrangementChanges_yes'),
						'get_price_alert_button_click'
					);
				},
				{
					'once': true
				}
			);
		});
		
		const modalElement = this.#getModalElement();
		
		modalElement.addEventListener('hidden.bs.modal', () => {
			this.#switchToOriginalModalContent();
		});
		
		modalElement.querySelector('.subscribeToArrangementChangesForm').addEventListener('submit', (ev) => {
			ev.preventDefault();
			
			this.#subscribeToArrangementChanges();
		});
		
		$(modalElement).on('click', '.switchToOriginalModalContent', () => {
			this.#switchToOriginalModalContent();
		});
	}
	
	async #subscribeToArrangementChanges() {
		const modalElement = this.#getModalElement(),
			submitButton = modalElement.querySelector('.submitBtn');
		
		submitButton.setAttribute('disabled', 'true');
		submitButton.classList.add('loader');
		
		 const result = await ajaxService.sendPost({
			'url' : 'user/subscribe-to-arrangement-changes',
			'data': {
				'arrangementId': this.params.arrangementId,
				'email'        : modalElement.querySelector('.emailInput').value
			}
		});
		
		this.#processSubscribeToArrangementChangesResponse(result);
		
		submitButton.removeAttribute('disabled');
		submitButton.classList.remove('loader');
	}
	
	#processSubscribeToArrangementChangesResponse({xhr, response}) {
		const responseObject = typeof xhr === 'object' ? xhr : response,
			{
			      responseJSON = {}
		      } = responseObject,
		      {resultHTML} = responseJSON;
		
		if (resultHTML) {
			const originalContent = this.#getModalElement().querySelector('.originalContent');
			
			originalContent.classList.add('d-none');
			originalContent.insertAdjacentHTML('afterend', resultHTML);
			
			this.#initFilteredArrangements();
			
			// track successful subscription
			if (responseObject.status === 201) {
				abTestService.sendEvent(
					getTestNameFromVariation('allowSubscribeToArrangementChanges_no', 'allowSubscribeToArrangementChanges_yes'),
					'subscribed_to_price_alert'
				);
			}
		}
	}
	
	#switchToOriginalModalContent() {
		const modalElement = this.#getModalElement();
		
		modalElement.querySelector('.originalContent').classList.remove('d-none');
		
		const nonOriginalContent = modalElement.querySelectorAll('.modal-body > :not(.originalContent)');
		
		nonOriginalContent.forEach((content) => {
			content.remove();
		});
	}
	
	#initFilteredArrangements() {
		contentService.initPopovers({
			'params': contentService.customPopOverMarkup()
		});
		
		const arrangementListItemClubLogoStr = '.arrangementListItem .clubLogo';
		
		if ($(arrangementListItemClubLogoStr).length) {
			lazyLoad({
				'elements_selector': arrangementListItemClubLogoStr
			});
		}
	}
	
	/**
	 * @returns {HTMLElement}
	 */
	#getModalElement() {
		return document.querySelector('#subscribeToArrangementChangesModal');
	}
	
}

export default SubscribeToArrangementChangesComponent;